export default "__VITE_ASSET__1d785378__"